import { useEffect, useState } from "react";
import {
  RiArrowDownSLine,
  RiArrowRightSLine,
  RiArrowUpSLine,
} from "react-icons/ri";
import { useParams } from "react-router-dom";

export default function BasicInfo({ setData, nationality_data, initialState }) {
  const [show, setShow] = useState(true);
  const { projectId } = useParams();
  const [name, setName] = useState("");
  const [JobDescription, setJobDescription] = useState("");
  const [vBenefitToggle, setvBenefitToggle] = useState(false);
  const [vCostToggle, setvCostToggle] = useState(false);
  const [vBenefitValue, setvBenefitValue] = useState("");
  const [vCostAmount, setvCostAmount] = useState("");
  const [nationality, setNationality] = useState();

  useEffect(() => {
    if (!vBenefitToggle) {
      setvBenefitValue();
    }
    if (!vCostToggle) {
      setvCostAmount();
    }
  }, [vCostToggle, vBenefitToggle]);

  useEffect(() => {
    console.log(initialState, "initial");
    setName(initialState?.name);
    setJobDescription(initialState?.description);
    setvBenefitToggle(initialState?.v_benefit == "YES" ? true : false);
    setvBenefitValue(initialState?.v_benefit_value);
    setvCostToggle(initialState?.v_cost == "YES" ? true : false);
    setvCostAmount(initialState?.v_cost_value);
    setNationality(initialState?.nationality_id);

    setData((prev) => ({
      ...prev,
      project_id: projectId,
      name: initialState?.name,
      description: initialState?.description,
      ...(initialState?.v_cost == "YES"
        ? {
            v_cost: "YES",
            v_cost_value: initialState?.v_cost_value,
          }
        : { v_cost: "NO" }),
      ...(initialState?.v_benefit == "YES"
        ? {
            v_benefit: "YES",
            v_benefit_value: initialState?.v_benefit_value,
          }
        : { v_benefit: "NO" }),
      nationality_id: initialState?.nationality_id,
    }));
  }, [initialState]);

  useEffect(() => {
    setData((prev) => ({
      ...prev,
      project_id: projectId,
      name: name,
      description: JobDescription,
      ...(vCostToggle
        ? {
            v_cost: "YES",
            v_cost_value: vCostAmount,
          }
        : { v_cost: "NO", v_cost_value: 0 }),
      ...(vBenefitToggle
        ? {
            v_benefit: "YES",
            v_benefit_value: vBenefitValue,
          }
        : { v_benefit: "NO", v_benefit_value: 0 }),
      nationality_id: nationality,
    }));
  }, [
    name,
    JobDescription,
    vBenefitToggle,
    vCostToggle,
    vBenefitValue,
    vCostAmount,
    nationality,
  ]);

  //call setData
  // setData(basicInfos, "basicInfo");

  return (
    <div className=" w-full flex flex-wrap md:flex-nowrap">
      <div className="max-w-xs w-full flex gap-3 items-center h-fit">
        <button
          className="p-1 rounded-md ring-1 ring-slate-200"
          type="button"
          onClick={() => setShow((p) => !p)}
        >
          {show ? (
            <RiArrowDownSLine size={"1.4rem"} />
          ) : (
            <RiArrowRightSLine size={"1.4rem"} />
          )}
        </button>
        <div>
          <h2 className="font-semibold">Basic Info</h2>
          <p>Enter basic details here</p>
        </div>
      </div>
      <div
        className={` w-full m-2 px-4 rounded-md transition-all overflow-hidden ${
          show ? "h-auto py-4 ring-1 ring-slate-200 " : "h-0"
        }`}
      >
        <div className="form-control w-full ">
          <label className="label">
            <span className="label-text">Job Enquiry Name</span>
          </label>
          <input
            type="text"
            placeholder="Type here"
            className="input input-bordered w-full "
            defaultValue={name}
            required={true}
            onChange={(e) => setName(String(e.target.value).toUpperCase())}
          />
        </div>
        <div className="form-control w-full ">
          <label className="label">
            <span className="label-text">Description</span>
          </label>
          <textarea
            className="textarea textarea-bordered h-24"
            placeholder="Description"
            defaultValue={JobDescription}
            required
            onChange={(e) =>
              setJobDescription(String(e.target.value).toUpperCase())
            }
          ></textarea>
        </div>
        <div className="form-control mt-5 max-w-sm">
          <label className="label flex-wrap cursor-pointer justify-start gap-4">
            <input
              type="checkbox"
              className="toggle toggle-error"
              checked={vBenefitToggle}
              onChange={() => setvBenefitToggle(!vBenefitToggle)}
              // required
            />
            <div>
              <h3 className="label-text font-semibold">VBenefit in SR</h3>
            </div>
          </label>
        </div>
        {vBenefitToggle && (
          <div className="form-control w-full ">
            <input
              type="number"
              placeholder="Type here"
              className="input input-bordered w-full "
              value={vBenefitValue}
              required
              onChange={(e) => setvBenefitValue(e.target.value)}
            />
          </div>
        )}
        <div className="form-control  max-w-sm">
          <label className="label flex-wrap cursor-pointer justify-start gap-4">
            <input
              type="checkbox"
              className="toggle toggle-error"
              checked={vCostToggle}
              onChange={() => setvCostToggle(!vCostToggle)}
              // required
            />
            <div>
              <h3 className="label-text font-semibold">VCost Amount</h3>
            </div>
          </label>
        </div>
        {vCostToggle && (
          <div className="form-control w-full ">
            <input
              type="number"
              placeholder="Type here"
              className="input input-bordered w-full "
              value={vCostAmount}
              required
              onChange={(e) => setvCostAmount(e.target.value)}
            />
          </div>
        )}
        <div className="form-control w-full">
          <h3 className="label">Nationality</h3>
          <select
            onChange={(e) => setNationality(e.target.value)}
            placeholder="Select Nationality"
            className="select select-sm select-bordered"
            required
            value={nationality}
          >
            <option value="select" hidden>
              Select an option
            </option>
            {nationality_data?.map((item, index) => (
              <option key={index} value={item.id}>
                {item.name}
              </option>
            ))}
          </select>
        </div>
      </div>
    </div>
  );
}
